import { TranslatePipe } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';

import { ProfileService, Trainer } from '../../_services';

@Component({
    selector: 'jhi-trainers',
    templateUrl: 'profile.component.html',
    styleUrls: ['profile.component.scss'],
    providers: [TranslatePipe],
})
export class ProfileComponent implements OnInit {
    profile: Trainer = new Trainer(null, '', '', '', '', '', true, [], '');
    success: boolean = false;
    pictureFileError: string = '';
    time = '';

    constructor(private profileService: ProfileService) {}

    ngOnInit() {
        this.loadCurrentTrainer();
    }

    loadCurrentTrainer() {
        this.updateTime();
        this.profileService.findCurrent().subscribe((profile) => {
            this.profile = profile;
        });
    }

    isBioFormValid() {
        return this.profile.bio && this.profile.bio.length > 1;
    }

    saveBio() {
        if (!this.isBioFormValid()) {
            return;
        }
        this.profileService
            .saveBioForCurrent(this.profile.bio)
            .subscribe(() => {
                this.success = true;
                setTimeout(() => {
                    this.success = false;
                }, 2 * 1000);
            });
    }

    updateTime() {
        this.time = new Date().getTime() + '';
    }

    resetPicture() {
        this.profileService
            .resetPictureForCurrent()
            .subscribe(() => this.loadCurrentTrainer());
    }

    pictureFileChange($event) {
        const files = $event.srcElement.files;
        this.pictureFileError = '';
        if (files.length == 1) {
            const file = files[0];
            if (file.size > 500000) {
                //500 ko
                this.pictureFileError =
                    'Merci de selectionner une image de moins de 500 ko';
            } else {
                this.profileService
                    .uploadPictureFile(file)
                    .subscribe(() => this.loadCurrentTrainer());
            }
        } else {
            this.pictureFileError = 'Merci de selectionner un fichier';
        }
    }

    uploadPictureFile(file) {
        const url = 'server/index.php';
        let xhr = new XMLHttpRequest();
        let fd = new FormData();
        xhr.open('POST', url, true);
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4 && xhr.status == 200) {
                // Every thing ok, file uploaded
                console.log(xhr.responseText); // handle response.
            }
        };
        fd.append('upload_file', file);
        xhr.send(fd);
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/profile/profile.component.ts